export default {
    watch: {
        active(val) {
            this.$cache.active = val
        }
    }
}